import React from 'react';
import AppRoutes from '../routes';
import useKlaviyo from '../hooks/useKlaviyo';
import useStackAdaptPixel from '../hooks/useStackAdaptPixel';
import { useTwitterHeadScript } from '../hooks/useTwitterHeadScript';
import { useLocation } from 'react-router-dom';
import tracking from '../helpers/tracking';

function App() {
  // useKlaviyo();
  useTwitterHeadScript();
  const location = useLocation();
  useStackAdaptPixel();

  React.useEffect(() => {
    tracking.twitterPageViewTrack(location.pathname);
  }, [location]);

  return <AppRoutes />;
}

export default App;
